import type { MapSearchInput } from '@/shared/utils/queryUtils'

export const receivablesTableFields: MapSearchInput['path'] = {
    name: ['id', 'reference', 'debtor.name', 'debtorIdentifier.value'],
    number: ['debtorIdentifier.value'],
    date: ['createdAt', 'expectedInvoiceDate', 'expectedInvoiceDueDate', 'deliveredAt']
}
